import styles from './PricesPreview.module.scss';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { Article } from '@work4all/models/lib/Classes/Article.entity';
import { SinglePrice } from '@work4all/models/lib/Classes/SinglePrice.entity';

import { ArticleSinglePriceCell } from '../../../../dataDisplay/basic-table/utils/cells/ArticleSinglePriceCell';

export interface SinglePricesPreviewProps {
  singlePrices: SinglePrice[];
  article: Article;
}

export function SinglePricesPreview(props: SinglePricesPreviewProps) {
  const { singlePrices, article } = props;
  const { t } = useTranslation();

  if (!singlePrices || singlePrices.length === 0) {
    return null;
  }

  return (
    <div className={clsx(styles.container, styles.singlePriceGrid)}>
      {/* Header */}
      <div className={styles.headerCell}>{t('COMMON.PRICE_GROUP')}</div>
      <div className={clsx(styles.headerCell, styles.alignRight)}>
        {t('COMMON.PRICE')}
      </div>
      <div className={clsx(styles.headerCell, styles.lastColumn)}>
        {t('COMMON.CURRENCY_ABBREV')}
      </div>

      {/* Body */}
      {singlePrices.map((singlePrice, index) => (
        <>
          <div
            key={`price-group-${index}`}
            className={clsx(styles.bodyCell, {
              [styles.withBottomBorder]: index < singlePrices.length - 1,
            })}
          >
            {singlePrice.priceGroup?.name || '-'}
          </div>
          <div
            key={`price-${index}`}
            className={clsx(styles.bodyCell, styles.alignRight, {
              [styles.withBottomBorder]: index < singlePrices.length - 1,
            })}
          >
            <ArticleSinglePriceCell
              value={singlePrice.price || 0}
              row={{ original: article }}
              column={{
                id: `priceGroup-${singlePrice.priceGroupId}`,
                cellParams: {
                  priceGroupId: singlePrice.priceGroupId || 0,
                  hideUnit: true,
                },
              }}
              hideUnit
            />
          </div>
          <div
            key={`currency-${index}`}
            className={clsx(styles.bodyCell, styles.lastColumn, {
              [styles.withBottomBorder]: index < singlePrices.length - 1,
            })}
          >
            {singlePrice.priceGroup?.currency?.name || '€'}
          </div>
        </>
      ))}
    </div>
  );
}
